export const getDBPercentage = ({ value, reference = 6 }: { value: number; reference: number }) => {
  if (value <= -120 || !Number.isFinite(value)) {
    return 0
  }

  const val = value - reference

  const k = Math.pow(10, val / 20)

  return k * 100
}
